/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BusinessMemory,
  BusinessMemory$inboundSchema,
} from "./businessmemory.js";

export type ListBusinessMemoriesResponseBody = {
  memories: Array<BusinessMemory>;
  nextCursor?: string | undefined;
};

/** @internal */
export const ListBusinessMemoriesResponseBody$inboundSchema: z.ZodMiniType<
  ListBusinessMemoriesResponseBody,
  unknown
> = z.pipe(
  z.object({
    memories: z.array(BusinessMemory$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listBusinessMemoriesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListBusinessMemoriesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListBusinessMemoriesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBusinessMemoriesResponseBody' from JSON`,
  );
}
